import { Link } from "react-router-dom";
import { BloomHerLogo } from "@/components/BloomHerLogo";
import { Heart } from "lucide-react";

const HEALTHIE_URL = "https://secure.gethealthie.com/appointments/embed_appt?dietitian_id=16074150";

const GETS = [
  "A personalized 90-minute session with Angel Laurent, M.Ed., NCP, CHHP, ANP, FWHP",
  "Your written Bloom Blueprint, built live and yours to keep",
  "A clear next step for your body, your money, and your faith",
  "Room to ask the questions you have been carrying",
];

export default function BloomBlueprintSession() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "#FBF9F6" }} data-testid="bloom-blueprint-session">
      <div style={{ backgroundColor: "#42152F" }}>
        <div className="max-w-5xl mx-auto px-6 py-5 flex justify-center">
          <Link to="/"><BloomHerLogo className="h-8 brightness-0 invert" /></Link>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-14 lg:py-20 text-center">
        {/* Section 1 - Headline */}
        <p className="text-xs font-medium uppercase tracking-[0.22em]" style={{ color: "#9B7E8D" }}>The Bloom Blueprint</p>
        <h1 className="mt-4 font-serif text-5xl lg:text-6xl leading-[1.05]" style={{ color: "#42152F" }}>
          Your Bloom Blueprint Session
        </h1>
        <p className="mt-5 font-serif text-2xl lg:text-3xl leading-snug" style={{ color: "#622952" }}>
          90 minutes with Angel. One personalized plan for your health, your wealth, and your faith. Yours to keep.
        </p>

        {/* Section 2 - What it is */}
        <p className="mt-10 text-lg leading-relaxed" style={{ color: "#42152F" }}>
          The masterclass showed you that your health, wealth, and faith were never meant to be separate. This is where we build your plan. In 90 minutes together, we map where you are now and where you want to be, and you walk away with a written Bloom Blueprint made just for you. Not a worksheet. A real plan, in your hands.
        </p>

        {/* Section 3 - What you get */}
        <div className="mt-12 mx-auto max-w-xl text-left rounded-[2rem] p-8" style={{ backgroundColor: "#ffffff", border: "1px solid #EFD9E2" }}>
          <h2 className="font-serif text-3xl mb-5 text-center" style={{ color: "#42152F" }}>What you get</h2>
          <ul className="space-y-4">
            {GETS.map((g, i) => (
              <li key={i} className="flex items-start gap-3" style={{ color: "#42152F" }} data-testid={`bb-get-${i}`}>
                <span className="mt-0.5 h-7 w-7 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "#f4c6d9" }}>
                  <Heart className="h-4 w-4" style={{ color: "#622952" }} strokeWidth={2.5} fill="#622952" />
                </span>
                <span className="text-[15px] leading-relaxed">{g}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Section 4 - Price + button */}
        <div className="mt-12">
          <p className="font-serif text-6xl" style={{ color: "#42152F" }}>$397</p>
          <p className="mt-2 text-base" style={{ color: "#9B7E8D" }}>One session. One plan. One you that has it all.</p>
          <a href={HEALTHIE_URL} target="_blank" rel="noreferrer" data-testid="bb-book-button"
            className="mt-7 inline-flex items-center justify-center rounded-full px-10 py-4 text-base font-medium transition-all hover:opacity-90"
            style={{ backgroundColor: "#622952", color: "#FBF9F6" }}>
            Book My Session
          </a>
        </div>

        {/* Section 5 - Same-day bonus */}
        <div className="mt-12 mx-auto max-w-2xl rounded-[1.5rem] p-7 text-center" style={{ backgroundColor: "#f4c6d9", color: "#42152F" }} data-testid="bb-bonus">
          <p className="text-lg leading-relaxed font-medium">
            Book today and your $397 applies as full credit toward Radiance or Full Bloom, if you book your session the same day as your masterclass. This offer is only for today.
          </p>
        </div>

        {/* Section 6 - Closing line */}
        <p className="mt-12 font-serif text-2xl italic leading-snug" style={{ color: "#622952" }}>
          You don't need to pick just one. You can plan it all out, and start today.
        </p>
      </div>
    </div>
  );
}
